import { Box, Flex } from 'grid-styled'
import * as React from 'react'
import Layout from '../../components/Layout'
import { graphql, Link } from 'gatsby'
import Img from 'gatsby-image'

import Target from 'react-icons/lib/fa/bullseye'
import Award from 'react-icons/lib/fa/shield'
import Atlas from 'react-icons/lib/fa/skyatlas'
import Card from '../../components/Card'
import CTA from '../../components/CTA'

import {
  Announcement,
  Cards,
  Container,
  Hero,
  HeroContent,
  HeroFigure,
  HeroMain,
  SplitSection,
  SplitFigure,
  SplitContent,
  Text,
  ReadMore
} from '../../components/styles'
import { Button } from '../../components/Button'
import FAQs from '../../components/FAQs'
import Form from '../../components/Form'
import { SEOCases } from '../../components/case-studies/SEOCases'
import Arrow from '../../components/Arrow'
import Testimonials from '../../components/Testimonials'
import { testimonials } from '../testimonials'
import { Helmet } from 'react-helmet'
import seoImage from '../../images/seo.svg'

export const faqsInfo = [
  {
    title: 'Common SEO questions'
  },
  {
    answer: `Absolutely. We constantly see the results and benefits directly when our clients obtain more traffic, a higher conversion rate and more sales. We've seen it drastically impact many local businesses profits time and time again.`,
    question: 'Does SEO Really Work?'
  },
  {
    answer: `It doesn't matter if you’re a startup, local small business or a multinational enterprise. Our current world's demands are the same. A focus on digital precence and online strategy is vital. SEO will not only help you remain competitive, but will help you expand and grow in a modern, long term and sustainable way.`,
    question: 'Do I need SEO for my business?'
  },
  {
    answer: `There is a lot of variability by industry, but SEO is not some quick fix solution. It is part of a sustainable, and holistic strategy for medium to long term business growth. Whilst we have personally had some clients rank page one within a week or two, a good rule of thumb for tangible results is 3 - 6 months. For more short term results, you can also look into our AdWords services. This allows you to skip the SEO process and will start generating results for you in a matter of hours.`,
    question: 'What is the time fame for SEO?'
  },
  {
    answer:
      'Search engines like Google are always changing and updating – what worked yesterday to generate your results may not continue to work for you tomorrow. It is highly important to have specialists in the field who can help you adapt the strategy and maintain your results on an ongoing basis.',
    question: 'Should I just do SEO once?'
  },
  {
    answer:
      'Any SEO Agency that promises a #1 position is fooling you. They will seek out low competition keywords with almost no traffic. We strive to target the most valuable and important keywords which align with our overall strategy to grow your business. Although we can’t guarantee a number 1 position, our systems continue to work for countless businesses.',
    question: 'Can you guarantee a #1 position on Google?'
  },
  {
    answer:
      'Organic results are the results that appear in search engines, for free, based on an algorithm. Paid (or ‘inorganic’) search results appear at the top or side of a page – they are links that advertisers pay to appear on search engines.',
    question: 'What is the difference between organic and paid results?'
  },
  {
    answer:
      'We have a number of KPIs that we use to measure the success of our efforts. They provide us with the information we need to strengthen and improve your SEO strategies. We integrate everything with analytics tools and reporting suites to ensure you always know where you stand and what the results have been.',
    question: 'How do you measure the success of your results?'
  },
  {
    answer:
      'We will send you a monthly report that contains: What we have done and are doing to reach the SEO goals we outlined. The tangible impact our SEO efforts are having on your web presence and traffic. New SEO opportunities we are discovering. Historical ranking information for all the search terms we are targetting. Essentially, everything you need to make informed choices.',
    question: 'What reports do I get?'
  }
]

/* prettier-ignore */
interface IProps {
  data: {
    girl: {
      childImageSharp: {
        fluid: object
      }
    };
    guys: {
      childImageSharp: {
        fluid: object
      }
    };
    justpatios: {
      childImageSharp: {
        fluid: object
      }
    };
  }
}

export default ({ data }: IProps) => (
  <Layout>
    <Helmet>
      <title>
        Search Engine Optimisation - Evolved SEO Brisbane - Turboclicks
      </title>
      <meta
        name="description"
        content="We help businesses tangibly grow their business sales through effective and modern SEO practices. Don't miss out on the world's largest marketplace."
      />
    </Helmet>
    <Hero>
      <Container>
        <HeroContent>
          <HeroMain>
            <h1>Search engine optimisation</h1>
            <p>
              Dominate Google's first page and get up to 70 percent of all
              search traffic with search engine optimisation.
            </p>
            <Announcement to="/contact">
              Speak with a specialist
              <Arrow rotate="-90deg" />
            </Announcement>
            <Link to="/contact#form">
              <Button inverted={true}>Improve my SEO</Button>
            </Link>
          </HeroMain>

          <HeroFigure>
            <img src={seoImage} alt="Brisbane SEO Servces" />
          </HeroFigure>
        </HeroContent>
      </Container>
    </Hero>

    <Container>
      <Cards>
        <Card
          color="primary"
          title="Results driven"
          content="We have one primary focus with SEO, to increase sales and grow your bottom line. To this end we believe in transparency and so work diligently to report our results in detail on a regular basis."
        >
          <Target />
        </Card>

        <Card
          color="tertiary"
          title="Experienced"
          content="Search engines are constantly redefining their search algorithms – this means the rules are always changing. We value our ability to adapt. Just take a look at the results from our happy customers."
        >
          <Award />
        </Card>

        <Card
          color="purple"
          title="Evolved practices"
          content="Search engines have evolved. In the modern digital environment you need to think about more than just being on page 1. We align our efforts with your entire marketing strategy to holistically grow your business."
        >
          <Atlas />
        </Card>
      </Cards>
    </Container>

    <Box mt={4}>
      <Container
        image="//truework.com//images/customer-stories/background-c96746d7.jpg"
        full={true}
        padY={true}
      >
        <Container medium={true}>
          <h2>
            Our work has been featured on Channel 7, 9 News, ABC and more!
          </h2>
        </Container>
      </Container>
    </Box>

    <Container padY={true} medium={true}>
      <h3>Why SEO?</h3>
      <Text size="large">
        Open google. Type in a search query. See that first result? It's there
        because someone has taken the time to get it there. This is great SEO at
        work.
      </Text>

      <Text size="large">
        At Turboclicks, we work closely with you to design a strategy that
        generates more customers, increases your websites visits and makes more
        sales. It's an unfortuante but common sight: a website sitting there,
        somewhere on the web, unseen. One of the modern worlds most powerful
        tools for growth left forgotten in the shadows.
      </Text>

      <Text size="large">
        Google is the most popular search engine in the world, by far, and the
        data speaks to this fact:
        <ul>
          <li>
            Businesses on Google's first page reap 70% of all internet traffic
          </li>

          <li>
            Over 30% of all search traffic is taken by the business at the #1
            position
          </li>

          <li>
            Search results earned through SEO are up to 8.5x more likely to be
            clicked on than paid ads
          </li>
        </ul>
      </Text>
      <Text size="large">
        To get on the first page of Google is to make your voice heard. You
        can’t afford not to be there – especially when your competition already
        is.
      </Text>
      <Button inverted={true}>Help me get to #1</Button>
    </Container>

    <Container medium={true}>
      <SplitSection>
        <SplitFigure>
          <Img
            fluid={data.girl.childImageSharp.fluid}
            alt="Turboclicks business woman smiling"
          />
        </SplitFigure>
        <SplitContent>
          <h2>A unique approach to SEO</h2>
          <p>
            Unfortunately, it's not uncommon for SEO companies to apply the same
            approach to every client’s website. We take the time to understand
            your website and business to truly act effectively and generate
            results. We're a small agency and value our personal touch.
          </p>
          <ReadMore to="/contact">
            Discover the power of SEO <Arrow rotate="-90deg" />
          </ReadMore>
        </SplitContent>
      </SplitSection>
      <SplitSection alternate={true} padY={true}>
        <SplitFigure>
          <Img
            fluid={data.guys.childImageSharp.fluid}
            alt="Turboclicks happy partners without contracts"
          />
        </SplitFigure>
        <SplitContent>
          <h2>No lock in contracts</h2>
          <p>
            Whilst SEO is a long term investment which can radically transform
            your business – we recommend against signing an lock-in contract.
            Contracts remove the motivation for an agency to get you the best
            possible results.
          </p>
          <ReadMore to="/contact">
            Upgrade your strategy <Arrow rotate="-90deg" />
          </ReadMore>
        </SplitContent>
      </SplitSection>
    </Container>

    <CTA
      inverted={true}
      title="Not sure what's best for you?"
      subtitle="We’re here to help."
      button="Speak to a specialist"
    />

    <SEOCases image={data.justpatios.childImageSharp.fluid} />

    <Testimonials flushTop={true} testimonials={testimonials} />

    <FAQs data={faqsInfo} flushTop={true} />

    <Container padY={true} medium={true}>
      <h3>Why SEO?</h3>
      <h4>Competitor Research</h4>
      <Text size="large">
        Industries can be competitive. That's why we conduct a full review of
        the competition to ensure that we understand their strategies and
        efforts and can build on them and work around them to make sure you get
        to number one. We reverse engineer through a close study of those who
        are already excelling in your industry.
      </Text>
      <h4>Keyword Research</h4>
      <Text size="large">
        Keyword research is one of the most important parts of Search Engine
        Optimisation. Imagine putting all your efforts into targetting keywords
        such as "healthy resturants" when "healthy cafes" get 10x the search
        traffic. With our experience in the industry we can provide deep
        analysis and guidance on what is going to be the best traffic producing
        and sales generating keywords to target. We don't over-optimise or
        under-optimise. We simply strive for the best and most effective
        groupings of keywords for you personally.
      </Text>
      <h4>SEO Site Audit</h4>
      <Text size="large">
        Conducting a full SEO audit for Brisbane based businesses requires hours
        of review and analysis to determine what requires our attention. We have
        people trained in maketing, programming, design and writing to perform a
        strategic analysis of what can be improved from meny varying
        perspectives to make sure nothing is missed and everything is gained.
        And, what's more, we will actually fix everything for you and implement
        every single one of our recommendations at no extra cost.
      </Text>
      <h4>Link Building</h4>
      <Text size="large">
        Link building is the most important skill (and the most time consuming)
        in SEO. Google’s PageRank Algorithm doesn’t just analyse the content of
        a page – it also looks at how many people link to the page. Links are
        important because search engines view them as a vote of confidence for a
        page (the theory is that when someone links to another website, they’re
        declaring that it’s a reliable source of information). Google focuses on
        link quality (which relates to the authority of the page that is linking
        to your website and numerous other factors) as well as quantity.
      </Text>
      <h4>Optimised Content</h4>
      <Text size="large">
        The team at Google has publicly stated that content is among its top
        three ranking factors. We have specialist writers who create blogs
        posts, website contnent, advertisements, videos, PDFs and more. Boring
        content is boring. Our writers can't stand poor quality copy, everything
        they do is:
      </Text>
      <ul>
        <li>
          Well written, informative and entertaining (sometimes even poetic)
        </li>
        <li>Social and shareable</li>
        <li>Designed to please humans, and search engines</li>
        <li>Targeted to your audience</li>
        <li>Based on thorough analysis, data and research</li>
        <li>Crafted to get results</li>
      </ul>
    </Container>

    <Form />
  </Layout>
)

export const query = graphql`
  query SEOPageQuery {
    girl: file(relativePath: { eq: "girl.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    justpatios: file(relativePath: { eq: "turboclicks-justpatios-case.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }

    guys: file(relativePath: { eq: "guys.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
